<template>
  <div class="p-15">
    <el-card>
      <el-form ref="ruleForm" :model="searchForm" inline>
        <el-form-item prop="query.status">
          <status-option v-model="searchForm.query.status"></status-option>
        </el-form-item>
        <el-form-item>
          <el-button @click="resetPagination" type="primary">查询</el-button>
        </el-form-item>
        <el-form-item>
          <el-button @click="reset">重置</el-button>
        </el-form-item>
        <el-form-item class="fr">
          <import-export @success="init" :template="downloadUrl" :target="importUrl"></import-export>
        </el-form-item>
      </el-form>
    </el-card>
    <el-card class="m-t-20">
      <el-table :data="tableData">
        <el-table-column prop="code" label="券码"/>
        <el-table-column label="券码状态" width="120px">
          <template slot-scope="{row}">
            {{ statusName(row) }}
          </template>
        </el-table-column>
      </el-table>
      <pagination :changed="changePage" :total="total" :pagination="searchForm.pagination"/>
    </el-card>
  </div>
</template>

<script>
import statusOption from "@/views/Gift/components/status-option";
import {lemonMusicCodeApi} from "@/api/lemon-music-code";

export default {
  name: "list",
  components: {
    statusOption
  },
  computed: {
    statusName() {
      let options = [
        {label: '未发放', value: "normal"},
        {label: '已发放', value: "received"},
      ];
      return (row) => {
        return options.find(op => op.value === row.status)?.label
      }
    }
  },
  data() {
    return {
      importUrl: 'lemon-music-code/import',
      downloadUrl: 'lemon-music-code/template',
      searchForm: {
        query: {
          status: undefined,
        },
        pagination: {
          currentPage: 1,
          limit: 10
        }
      },
      tableData: [],
      total: 0
    }
  },
  methods: {
    resetPagination() {
      this.searchForm.pagination = { currentPage: 1, limit: 10 }
      this.init()
    },
    async loadLemonMusicCodeList() {
      const query = {
        ...this.searchForm,
      }
      const {collection, meta} = await lemonMusicCodeApi(query)
      this.tableData = collection
      this.total = meta.total
    },
    reset() {
      this.$refs.ruleForm.resetFields()
      this.searchForm.pagination.currentPage = 1
      this.init()
    },
    changePage(page) {
      this.searchForm = Object.assign(this.searchForm, page)
      this.init()
    },
    init() {
      this.loadLemonMusicCodeList()
    }
  },
  mounted() {
    this.init()
  }
}
</script>

<style scoped>

</style>
